import FormControl from '@mui/material/FormControl';
import { styled } from '@mui/material/styles';

const StyledFormControl = styled(FormControl)(({ disabledcolor = 'black' }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: 'white',
    textAlign: 'center',
    height: '40px',
    fontSize: '14px'
  },

  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: disabledcolor
  }
}));

export default StyledFormControl;
